import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getStockValueReport } from '@/api/reports';
import { BranchAgentService } from '@/services/branch-agent-service';
import { exportJson2Excel } from '@/utils/excel';
import { getQuery, formatJson } from '@/utils/index';
import { searchProducts } from '@/api/products';
import { getStocksByInvoice } from '@/api/inventory-inwards-logs';
import moment from 'moment';
import Pagination from '@/components/Pagination/index.vue';
let StockValueReport = class StockValueReport extends Vue {
  constructor() {
    super(...arguments);
    this.branchId = null;
    this.branchList = [];
    this.branchListLoading = false;
    this.reportData = [];
    this.listLoading = false;
    this.showFilters = false;
    // Drill-down navigation state
    this.currentView = 'branches';
    this.selectedBranch = null;
    this.selectedUnit = null;
    this.selectedProductRow = null;
    // Lazy-loaded sublists
    this.unitsList = [];
    this.productsList = [];
    // Product filter (remotely loaded list & selected value)
    this.selectedProduct = null;
    this.products = [];
    this.productListLoading = false;
    // Pagination & Sort state for the currently active products list view
    this.listQuery = {
      page: 1,
      limit: 10
    };
    this.unitSort = null;
    // Level 4 Logs state
    this.logsList = [];
    this.logsTotal = 0;
    this.logsLoading = false;
    this.logsQuery = {
      page: 1,
      limit: 10
    };
  }
  async created() {
    this.branchList = await BranchAgentService.fetchBranches(await BranchAgentService.assignBranchId());
    this.fetchData();
  }
  formatNumber(n) {
    if (!n && n !== 0) return '0.00';
    return Number(n).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  // Load branches (or units directly if branchId select dropdown is used)
  async fetchData() {
    this.listLoading = true;
    try {
      const params = {};
      if (this.branchId) params.branchId = this.branchId;
      const res = await getStockValueReport(params);
      if (this.branchId) {
        const matchingBranch = this.branchList.find(b => b.id === this.branchId);
        this.selectedBranch = {
          branchId: this.branchId,
          branch: matchingBranch ? matchingBranch.name : 'Selected Branch',
          branchCode: matchingBranch ? matchingBranch.code : '',
          branchTotalValue: 0
        };
        this.unitsList = res || [];
        this.selectedBranch.branchTotalValue = this.unitsList.reduce((acc, u) => acc + (u.unitTotalValue || 0), 0);
        this.currentView = 'units';
        this.selectedUnit = null;
        this.selectedProduct = null;
        this.products = [];
      } else {
        this.reportData = res || [];
        this.currentView = 'branches';
        this.selectedBranch = null;
        this.selectedUnit = null;
        this.unitsList = [];
        this.productsList = [];
        this.selectedProduct = null;
        this.products = [];
      }
    } catch (err) {
      this.$message.error('Error fetching stock data');
    } finally {
      this.listLoading = false;
    }
  }
  async selectBranch(row) {
    this.listLoading = true;
    try {
      this.selectedBranch = row;
      this.selectedUnit = null;
      this.selectedProduct = null;
      this.products = [];
      const res = await getStockValueReport({
        branchId: row.branchId
      });
      this.unitsList = res || [];
      this.currentView = 'units';
    } catch (err) {
      this.$message.error('Error fetching units');
    } finally {
      this.listLoading = false;
    }
  }
  async selectUnit(row) {
    this.listLoading = true;
    try {
      this.selectedUnit = row;
      this.selectedProduct = null;
      this.products = [];
      const res = await getStockValueReport({
        unitId: row.unitId
      });
      this.productsList = res || [];
      this.currentView = 'products';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.unitSort = null;
    } catch (err) {
      this.$message.error('Error fetching products');
    } finally {
      this.listLoading = false;
    }
  }
  navigateTo(view) {
    this.currentView = view;
    this.selectedProduct = null;
    this.products = [];
    this.selectedProductRow = null;
    this.logsList = [];
    if (view === 'branches') {
      this.selectedBranch = null;
      this.selectedUnit = null;
      this.unitsList = [];
      this.productsList = [];
      this.branchId = null;
      this.fetchData();
    } else if (view === 'units') {
      this.selectedUnit = null;
      this.productsList = [];
    }
  }
  goBack() {
    this.selectedProduct = null;
    this.products = [];
    if (this.currentView === 'logs') {
      this.currentView = 'products';
      this.selectedProductRow = null;
      this.logsList = [];
    } else if (this.currentView === 'products') {
      this.currentView = 'units';
      this.selectedUnit = null;
      this.productsList = [];
    } else if (this.currentView === 'units') {
      this.navigateTo('branches');
    }
  }
  async selectProduct(row) {
    this.selectedProductRow = row;
    this.logsQuery.page = 1;
    await this.fetchLogs();
    this.currentView = 'logs';
  }
  async fetchLogs() {
    if (!this.selectedProductRow || !this.selectedUnit || !this.selectedBranch) return;
    this.logsLoading = true;
    try {
      const params = {
        branchId: this.selectedBranch.branchId,
        unitId: this.selectedUnit.unitId,
        productId: this.selectedProductRow.productId,
        variationId: this.selectedProductRow.productsVariationId,
        productsVariationId: this.selectedProductRow.productsVariationId,
        page: undefined,
        limit: undefined
      };
      const res = await getStocksByInvoice(params);
      const allLogs = res.data || [];
      const activeInwards = this.computeFIFONetInwards(allLogs);
      const consolidatedRow = this.getConsolidatedStockRow(activeInwards);
      this.logsList = [consolidatedRow];
      this.logsTotal = 1;
    } catch (err) {
      this.$message.error('Error fetching inventory logs');
    } finally {
      this.logsLoading = false;
    }
  }
  getConsolidatedStockRow(activeInwards) {
    const row = {
      productName: this.selectedProductRow.productName,
      variationName: this.selectedProductRow.variationName || '-',
      stock: this.selectedProductRow.stock,
      slab30: 0,
      slab45: 0,
      slab60: 0,
      slab90: 0,
      slab120: 0,
      slabAbove: 0
    };
    for (const inward of activeInwards) {
      const created = moment(inward.createdTimestamp);
      const days = moment().diff(created, 'days');
      const qty = Number(inward.netQuantity) || 0;
      if (days <= 30) row.slab30 += qty;else if (days <= 45) row.slab45 += qty;else if (days <= 60) row.slab60 += qty;else if (days <= 90) row.slab90 += qty;else if (days <= 120) row.slab120 += qty;else row.slabAbove += qty;
    }
    return row;
  }
  computeFIFONetInwards(allLogs) {
    const sortedLogs = [...allLogs].sort((a, b) => new Date(a.createdTimestamp).getTime() - new Date(b.createdTimestamp).getTime());
    let totalOutward = 0;
    for (const log of sortedLogs) {
      const action = this.getActionLabel(log.action);
      if (action === 'OUT') {
        totalOutward += Number(log.quantity) || 0;
      }
    }
    const activeInwards = [];
    for (const log of sortedLogs) {
      const action = this.getActionLabel(log.action);
      if (action === 'IN') {
        const qty = Number(log.quantity) || 0;
        if (totalOutward >= qty) {
          totalOutward -= qty;
        } else {
          const remainingQty = qty - totalOutward;
          totalOutward = 0;
          activeInwards.push({
            ...log,
            netQuantity: remainingQty
          });
        }
      }
    }
    return activeInwards.reverse();
  }
  getPaginatedLogs() {
    const page = this.logsQuery.page;
    const limit = this.logsQuery.limit;
    return this.logsList.slice((page - 1) * limit, page * limit);
  }
  getActionLabel(actionVal) {
    if (!actionVal && actionVal !== 0) return 'N/A';
    const val = String(actionVal).toLowerCase();
    if (val === '0' || val === 'inward' || val === 'in') {
      return 'IN';
    }
    if (val === '1' || val === 'outward' || val === 'out') {
      return 'OUT';
    }
    return val.toUpperCase();
  }
  get filteredProducts() {
    let products = [...this.productsList];
    if (this.selectedProduct) {
      if (this.selectedProduct.startsWith('product-')) {
        const id = Number(this.selectedProduct.replace('product-', ''));
        products = products.filter(p => p.productId === id);
      } else if (this.selectedProduct.startsWith('variation-')) {
        const id = Number(this.selectedProduct.replace('variation-', ''));
        products = products.filter(p => p.productsVariationId === id);
      }
    }
    return products;
  }
  get total() {
    return this.filteredProducts.length;
  }
  getList() {
    // Client-side pagination handler. Slicing in getUnitProducts automatically updates because listQuery page/limit are reactive.
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        const res = await searchProducts(getQuery({
          keyword: query
        }));
        this.products = res || [];
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  flexColumnWidth(prop, label, minWidth = 80) {
    let list = [];
    // Choose appropriate list based on properties
    if (['branch', 'branchCode', 'branchTotalValue'].includes(prop)) {
      list = this.reportData;
    } else if (['unit', 'unitTotalValue'].includes(prop)) {
      list = this.unitsList;
    } else if (['productName', 'variationName', 'stock', 'mrp', 'discountType', 'rate', 'value'].includes(prop)) {
      list = this.productsList;
    }
    let maxLen = label.length;
    for (const item of list) {
      let val = item[prop];
      if (val === null || val === undefined) {
        val = '';
      }
      if (['branchTotalValue', 'unitTotalValue', 'value', 'rate', 'mrp'].includes(prop)) {
        val = '₹ ' + this.formatNumber(Number(val));
      } else if (prop === 'discountType') {
        if (item.discountType === 'nett') {
          val = `Nett: ₹${this.formatNumber(item.nettDiscount)}`;
        } else if (item.discountType === 'percent') {
          val = `Percent: ${item.percentDiscount}%`;
        } else {
          val = 'No policy';
        }
      }
      const len = String(val).length;
      if (len > maxLen) {
        maxLen = len;
      }
    }
    // Multiply by average character width (e.g., 9px) and add padding (e.g., 30px)
    const calculatedWidth = maxLen * 9 + 30;
    return `${Math.max(calculatedWidth, minWidth)}px`;
  }
  getUnitProducts() {
    const products = [...this.filteredProducts];
    if (this.unitSort && this.unitSort.order) {
      const isAsc = this.unitSort.order === 'ascending';
      const prop = this.unitSort.prop;
      products.sort((a, b) => {
        const valA = a[prop];
        const valB = b[prop];
        if (typeof valA === 'number' && typeof valB === 'number') {
          return isAsc ? valA - valB : valB - valA;
        }
        return isAsc ? String(valA).localeCompare(String(valB)) : String(valB).localeCompare(String(valA));
      });
    }
    // Paginate sliced products
    const page = this.listQuery.page;
    const limit = this.listQuery.limit;
    return products.slice((page - 1) * limit, page * limit);
  }
  handleUnitSortChange(sortData) {
    const {
      prop,
      order
    } = sortData;
    this.unitSort = {
      prop,
      order
    };
    this.listQuery.page = 1;
  }
  // Summaries
  getBranchSummary(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'branchTotalValue') {
        const values = data.map(item => Number(item[column.property]));
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  getUnitSummary(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'unitTotalValue') {
        const values = data.map(item => Number(item[column.property]));
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  getProductSummary(param) {
    const {
      columns
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'value') {
        const sum = this.filteredProducts.reduce((acc, p) => acc + (p.value || 0), 0);
        sums[index] = '₹ ' + this.formatNumber(sum);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  // Export excel
  exportExcel() {
    let tHeader = [];
    let filterVal = [];
    let data = [];
    let filename = 'stock-value-report';
    if (this.currentView === 'branches') {
      tHeader = ['Branch Name', 'Branch Code', 'Total Stock Value'];
      filterVal = ['branch', 'branchCode', 'branchTotalValue'];
      data = this.reportData;
      filename = 'branches-stock-value';
    } else if (this.currentView === 'units' && this.selectedBranch) {
      tHeader = ['Unit Name', 'Unit Stock Value'];
      filterVal = ['unit', 'unitTotalValue'];
      data = this.unitsList;
      filename = `${this.selectedBranch.branch}-units-stock-value`;
    } else if (this.currentView === 'products' && this.selectedUnit) {
      tHeader = ['Product', 'Variation', 'Stock', 'MRP', 'Rate', 'Value'];
      filterVal = ['productName', 'variationName', 'stock', 'mrp', 'rate', 'value'];
      data = this.filteredProducts;
      filename = `${this.selectedUnit.unit}-products-stock-value`;
    } else if (this.currentView === 'logs' && this.selectedProductRow) {
      tHeader = ['Product', 'Variation', 'Total Stock', '0-30 days', '31-45 days', '46-60 days', '61-90 days', '91-120 days', '120+ days'];
      filterVal = ['productName', 'variationName', 'stock', 'slab30', 'slab45', 'slab60', 'slab90', 'slab120', 'slabAbove'];
      data = this.logsList;
      filename = `${this.selectedProductRow.productName}-logs-stock-value`;
    }
    const exportedData = formatJson(filterVal, data);
    exportJson2Excel(tHeader, exportedData, filename);
  }
};
StockValueReport = __decorate([Component({
  name: 'StockValueReport',
  components: {
    Pagination
  }
})], StockValueReport);
export default StockValueReport;